export default "__VITE_ASSET__C7pTbji3__"